import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import get from "lodash/get";
import ReportService from "../../services/ReportService";

const useSponsorReportData = (
  estateId,
  additionalUnits,
  startDate,
  endDate,
  options
) => {
  return useQuery({
    queryKey: ["sponsorReport", estateId, additionalUnits, startDate, endDate],
    queryFn: async () => {
      const res = await ReportService.getSponsorData({
        estateId: estateId,
        standaloneEstates: additionalUnits,
        startDate: dayjs(startDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss"),
        endDate: dayjs(endDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss"),
      });
      return get(res, "data");
    },
    ...options,
  });
};

export default useSponsorReportData;
